module.exports = __webpack_public_path__ + "img/blue_117.f8dc6ca3.png";